import React from "react";
import Sidebar from "../components/Sidebar";

const Audit: React.FC = () => {
  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar />
      <div className="flex-1 p-8">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">บันทึกกิจกรรม</h1>
          <p className="text-gray-600 mb-6">ติดตามและตรวจสอบกิจกรรมในระบบ</p>

          <div className="bg-white rounded-lg shadow overflow-hidden border border-gray-200">
            <table className="w-full">
              <thead className="bg-gray-50 border-b border-gray-200">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">วันที่เวลา</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">ผู้ใช้</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">การกระทำ</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">รายละเอียด</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">IP Address</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                <tr className="hover:bg-gray-50">
                  <td className="px-6 py-4 text-sm text-gray-900">2026-04-21 23:30:00</td>
                  <td className="px-6 py-4 text-sm text-gray-900">admin@comex.com</td>
                  <td className="px-6 py-4 text-sm text-gray-900">เข้าสู่ระบบ</td>
                  <td className="px-6 py-4 text-sm text-gray-900">ล็อกอินสำเร็จ</td>
                  <td className="px-6 py-4 text-sm text-gray-900">192.168.1.1</td>
                </tr>
                <tr className="hover:bg-gray-50">
                  <td className="px-6 py-4 text-sm text-gray-900">2026-04-21 23:25:00</td>
                  <td className="px-6 py-4 text-sm text-gray-900">admin@comex.com</td>
                  <td className="px-6 py-4 text-sm text-gray-900">อัปเดตการตั้งค่า</td>
                  <td className="px-6 py-4 text-sm text-gray-900">แก้ไขการตั้งค่า PromptPay</td>
                  <td className="px-6 py-4 text-sm text-gray-900">192.168.1.1</td>
                </tr>
                <tr className="hover:bg-gray-50">
                  <td className="px-6 py-4 text-sm text-gray-900">2026-04-21 23:20:00</td>
                  <td className="px-6 py-4 text-sm text-gray-900">somchai@example.com</td>
                  <td className="px-6 py-4 text-sm text-gray-900">สร้างคำสั่งซื้อ</td>
                  <td className="px-6 py-4 text-sm text-gray-900">สร้างคำสั่งซื้อ ORD-002</td>
                  <td className="px-6 py-4 text-sm text-gray-900">192.168.1.2</td>
                </tr>
                <tr className="hover:bg-gray-50">
                  <td className="px-6 py-4 text-sm text-gray-900">2026-04-21 23:15:00</td>
                  <td className="px-6 py-4 text-sm text-gray-900">system</td>
                  <td className="px-6 py-4 text-sm text-gray-900">ชำระเงิน</td>
                  <td className="px-6 py-4 text-sm text-gray-900">คำสั่งซื้อ ORD-001 ชำระสำเร็จ</td>
                  <td className="px-6 py-4 text-sm text-gray-900">-</td>
                </tr>
                <tr className="hover:bg-gray-50">
                  <td className="px-6 py-4 text-sm text-gray-900">2026-04-21 23:10:00</td>
                  <td className="px-6 py-4 text-sm text-gray-900">admin@comex.com</td>
                  <td className="px-6 py-4 text-sm text-gray-900">เพิ่มผู้ใช้</td>
                  <td className="px-6 py-4 text-sm text-gray-900">เพิ่มผู้ใช้ใหม่ somchai@example.com</td>
                  <td className="px-6 py-4 text-sm text-gray-900">192.168.1.1</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Audit;
